/**
 * Ultimi prodotti visualizzati
 * - Salva in localStorage i handle dei prodotti visitati
 * - Popola il carosello con la product-card della PLP da /products/{handle}?view=recently-viewed
 */
(function() {
  const STORAGE_KEY = 'qb24_recently_viewed';
  const MAX_ITEMS = 12;

  function getRecentHandles() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  function saveRecentHandles(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
    } catch (e) {
      console.warn('Recently viewed: localStorage error', e);
    }
  }

  function addToRecentlyViewed(handle) {
    if (!handle) return;
    let handles = getRecentHandles();
    handles = handles.filter(h => h !== handle);
    handles.unshift(handle);
    saveRecentHandles(handles);
  }

  async function loadAndRender(sectionEl) {
    const currentHandle = sectionEl.dataset.currentHandle;
    const slidesContainer = document.getElementById('recently-viewed-slides-' + sectionEl.dataset.sectionId);
    if (!slidesContainer) return;

    const handles = getRecentHandles().filter(h => h !== currentHandle);
    if (handles.length === 0) {
      sectionEl.style.display = 'none';
      return;
    }

    const slides = [];
    for (const handle of handles) {
      try {
        const res = await fetch(`/products/${encodeURIComponent(handle)}?view=recently-viewed`);
        if (!res.ok) continue;
        const cardHtml = (await res.text()).trim();
        if (cardHtml.startsWith('<product-card')) {
          slides.push(`<div class="swiper-slide">${cardHtml}</div>`);
        }
      } catch (e) {
        console.warn('Recently viewed: fetch error for', handle, e);
      }
    }

    if (slides.length === 0) {
      sectionEl.style.display = 'none';
      return;
    }

    slidesContainer.innerHTML = slides.join('');

    // Aggiorna lo swiper dopo aver aggiunto le slide
    const tryUpdate = () => {
      const swiperEl = sectionEl.querySelector('theme-swiper');
      const swiperInstance = swiperEl?.swiper || sectionEl.querySelector('.swiper')?.swiper;
      if (swiperInstance) {
        swiperInstance.update();
      }
    };
    tryUpdate();
    setTimeout(tryUpdate, 100);
    setTimeout(tryUpdate, 500);

    alignArrowsToImage(sectionEl);
  }

  function alignArrowsToImage(sectionEl) {
    const image = sectionEl.querySelector('product-card a img');
    const arrows = sectionEl.querySelectorAll('.swiper-button-prev, .swiper-button-next');
    if (!image || arrows.length === 0) return;

    const align = () => {
      if (!image.offsetHeight) return;
      arrows.forEach(arrow => {
        arrow.style.setProperty('--swiper-navigation-top-offset', `calc(${image.offsetHeight / 2}px - var(--swiper-navigation-size) / 2)`);
      });
    };
    align();
    new ResizeObserver(align).observe(image);
  }

  function init() {
    if (window.recentlyViewedInitialized) return;
    window.recentlyViewedInitialized = true;

    // Tracking: su pagina prodotto salva il handle in localStorage
    const productHandle = document.body.dataset.currentProductHandle;
    if (productHandle) {
      addToRecentlyViewed(productHandle);
    }

    // Rendering: su pagina account mostra il carosello
    const sectionEl = document.querySelector('.recently-viewed-section');
    if (sectionEl) {
      loadAndRender(sectionEl);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
